import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';

import useGetCustomMenuQuery from 'App/hooks/useGetCustomMenuQuery';
import SelectAllField from 'Shared/form/SelectAllField';
import withFormikFields from 'Shared/form/withFormikFields';
import CommonPatientFieldWrapper from '../CommonPatientFieldWrapper';

const HighRiskReasonsField = ({ fieldValues: { highRisk } }) => {
    const { data: highRiskReasons, isLoading: isHighRiskReasonsLoading } = useGetCustomMenuQuery('high_risk_reason');

    if (!highRisk?.value) {
        return null;
    }

    return (
        <CommonPatientFieldWrapper fieldName="highRiskReasons">
            {(commonProps) => (
                <Col md={3}>
                    <SelectAllField
                        {...commonProps}
                        label="High-Risk Reasons"
                        options={highRiskReasons || []}
                        isLoading={isHighRiskReasonsLoading}
                    />
                </Col>
            )}
        </CommonPatientFieldWrapper>
    );
};

HighRiskReasonsField.propTypes = {
    fieldValues: PropTypes.shape({
        highRisk: PropTypes.shape({
            value: PropTypes.bool,
        }),
    }).isRequired,
};

export default withFormikFields({ WrappedComponent: HighRiskReasonsField, fieldNames: ['highRisk'] });
